import * as React from "react";
const NewsSee2 = (props) => (
  <svg
    width={30}
    height={21}
    viewBox="0 0 30 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 9.45V11.55C7.5 24.15 22.5 24.15 30 11.55V9.45C22.5 -3.15 7.5 -3.15 0 9.45ZM15 18.9C10.8574 18.9 7.5 15.1397 7.5 10.5C7.5 5.86031 10.8574 2.1 15 2.1C19.1426 2.1 22.5 5.86031 22.5 10.5C22.5 15.1397 19.1426 18.9 15 18.9ZM15 5.775C15 5.23031 15.0996 4.71844 15.252 4.22625C15.1641 4.21969 15.0879 4.2 15 4.2C11.8945 4.2 9.375 7.02187 9.375 10.5C9.375 13.9781 11.8945 16.8 15 16.8C18.1055 16.8 20.625 13.9781 20.625 10.5C20.625 10.4016 20.6016 10.3162 20.6016 10.2178C20.168 10.3884 19.7051 10.5 19.2188 10.5C16.8867 10.5 15 8.38687 15 5.775Z"
      fill="#BD9F3F"
    />
  </svg>
);
export default NewsSee2;
